// 首页
import React, { useState } from "react";
// 引入符合图2排版规范的完整官方图标库
import { LeftOutlined, ArrowDownOutlined } from "@ant-design/icons";

import "./index.less";
import { Navigate, useNavigate } from "react-router-dom";

import bgZnpc from "@/assets/img/bg_znpc@2x.png";
import bgZnyys from "@/assets/img/bg_znyys@2x.png";
import bgSwcx from "@/assets/img/bg_swcx_new@2x.png";
import bgYsrj from "@/assets/img/bg_ysrj@2x.png";
import bgStys from "@/assets/img/bg_stys_new@2x.png";
import bgSpdz from "@/assets/img/bg_spdz_new@2x.png";
import bgYygl from "@/assets/img/bg_yygl_new@2x.png";
import bgYd from "@/assets/img/bg_ydyy_new@2x.png";

// 🌟 🌟 🌟 核心接收：解构接收由顶层 App.js 透传下发的 onOpenSidebar 中央调度器 🌟 🌟 🌟
const AgentPlaza = ({
  onBack,
  onSelectAgent,
  onOpenSidebar,
  userId,
  handleToggleCareMode,
  isCareMode,
}) => {
  const renderNutritionContent = () => (
    <div className="tab-content nutrition-tab">
      {/* 免费权益区区块 */}
      <div className="section-group-box free-zone-container">
        <div className="function-grid">
          <div
            className="grid-item"
            onClick={() => onSelectAgent("nutritionist")}
          >
            <div className="item-title">智能营养师</div>
            <div className="item-sub">
              随时在线的 AI 营养师，喂养疑问一键解决，省心又专业。
            </div>
            <img src={bgZnyys} className="item-bg" alt="" />
          </div>
          <div className="grid-item" onClick={() => onSelectAgent("meal_plan")}>
            <div className="item-title">智能配餐</div>
            <div className="item-sub">
              依托垂域大模型，科学定制带量食谱，轻松实现营养全面达标。
            </div>
            <img src={bgZnpc} className="item-bg" alt="" />
          </div>
          <div
            className="grid-item"
            onClick={() => onSelectAgent("recipe_customization")}
          >
            <div className="item-title">食谱定制</div>
            <div className="item-sub">
              自主选择爱吃或忌口食材，智能生成专属个性化定制食谱。
            </div>
            <img src={bgSpdz} className="item-bg" alt="" />
          </div>
          <div
            className="grid-item"
            onClick={() => onSelectAgent("assessment")}
          >
            <div className="item-title">营养评估</div>
            <div className="item-sub">
              饮食数据全面分析，营养缺口一目了然，饮食调整有据可依。
            </div>
            <img src={bgYsrj} className="item-bg" alt="" />
          </div>
        </div>
      </div>

      {/* 付费尊享区区块 */}
      <div className="section-group-box paid-zone-container">
        <div className="vip-features-list-box">
          {/* 运动营养 */}
          <div
            className="vip-card-item"
            style={{ backgroundImage: `url(${bgYd})` }}
            onClick={() => onSelectAgent("sport_nutrition")}
          >
            {/* <div className="vip-ribbon-tag">VIP</div> */}
            <div className="vip-card-content-left">
              <div className="vip-title-row">
                <h3>运动营养<span className="vip-title-small">（适用于4岁以上儿童）</span></h3>
              </div>
              <p className="vip-desc-text">
             联动运动项目与时长，智能精准换算所需营养补给。
              </p>
            </div>
          </div>
          {/* 生酮饮食 */}
          <div
            className="vip-card-item"
            style={{ backgroundImage: `url(${bgStys})` }}
            onClick={() => onSelectAgent("ketogenic_diet")}
          >
            {/* <div className="vip-ribbon-tag">VIP</div> */}
            <div className="vip-card-content-left">
              <div className="vip-title-row">
                <h3>生酮饮食</h3>
              </div>
              <p className="vip-desc-text">
                适配特殊疾病定制生酮食谱；支持全程追踪饮食与身体指标变化。
              </p>
            </div>
          </div>

          {/* 营养管理 */}
          {/* <div
            className="vip-card-item"
            style={{ backgroundImage: `url(${bgYygl})` }}
            onClick={() => onSelectAgent("nutrition_manage")}
          >
            <div className="vip-ribbon-tag">VIP</div>
            <div className="vip-card-content-left">
              <div className="vip-title-row">
                <h3>营养管理</h3>
              </div>
              <p className="vip-desc-text">
                联动运动智能精准换算所需营养补给，科学助力孩子健康发育。
              </p>
            </div>
          </div> */}

          {/* 生长发育 */}
          <div
            className="vip-card-item"
            style={{ backgroundImage: `url(${bgYygl})` }}
            onClick={() => onSelectAgent("growth_development")}
          >
            {/* <div className="vip-ribbon-tag">VIP</div> */}
            <div className="vip-card-content-left">
              <div className="vip-title-row">
                <h3>生长发育</h3>
              </div>
              <p className="vip-desc-text">
                围绕儿童生长发育需求，量身制定营养补充计划。
              </p>
            </div>
          </div>
          {/* 食物查询 */}
          <div
            className="vip-card-item"
            style={{ backgroundImage: `url(${bgSwcx})` }}
            onClick={() => onSelectAgent("food_query")}
          >
            {/* <div className="vip-ribbon-tag">VIP</div> */}
            <div className="vip-card-content-left">
              <div className="vip-title-row">
                <h3>食物查询</h3>
              </div>
              <p className="vip-desc-text">
                快速查询各类食物的营养成分与适配性，让家长喂养更安心。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="agent-plaza-wrapper">
      {/* 顶栏 */}
      <div className="plaza-header">
        <div className="header-left-brand">
          <LeftOutlined className="back" onClick={onBack} />
          <span className="title">饮食营养专区</span>
        </div>
      </div>

      {/* 主体滚动区 */}
      <div className="plaza-main-body">{renderNutritionContent()}</div>
    </div>
  );
};

export default AgentPlaza;
